import { render, staticRenderFns } from "./BSNewChat.vue?vue&type=template&id=8a2430f2"
import script from "./BSNewChat.vue?vue&type=script&lang=js"
export * from "./BSNewChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports